import { statusOf } from "@/lib/constants";

const SHORT_LABELS = { modification: "À modifier", a_valider: "À valider" };

export default function StatusBadge({ status, className = "", short = false }) {
  const s = statusOf(status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border whitespace-nowrap ${s.cls} ${className}`}
    >
      {short && SHORT_LABELS[status] ? SHORT_LABELS[status] : s.label}
    </span>
  );
}
